import styled from 'styled-components';

export const TabsWrapper = styled.div`
  display: inline-block;
  margin-bottom: 16px;
  z-index: 1;
`;
